import { Sidebar } from 'primereact/sidebar';
import React, { ReactNode } from 'react';
import { RxCross2 } from 'react-icons/rx';

type DrawerProps = {
    open: boolean;
    close: () => void;
    position: 'left' | 'right' | 'top' | 'bottom';
    children: ReactNode;
    className?: string;
    header?: ReactNode;
    width?: string;
    closeIcon?:boolean;
    showCloseIcon?:boolean;
};

const Drawer = (props: DrawerProps) => {
    return (
        <Sidebar
            className={`${props.width?props.width:"w-4/5"} dark:bg-sky-950 ${props.className}`}
            visible={props.open}
            position={props.position}
            closeIcon={props.closeIcon?<RxCross2 />:""}
            showCloseIcon={props.showCloseIcon || false}
            maskClassName='backdrop-blur-sm bg-opacity-50'
            onHide={props.close}
            header={props.header}
        >
            {props.children}
        </Sidebar>
    );
};

export default Drawer;
